// Where the dashboard sends its API calls.
//
// On the deployed dashboard we talk to the SAME ORIGIN and let the `/api/*`
// rewrite in vercel.json forward to the API server-side. This keeps the
// operator's browser off the raw API server IP — some ISPs (confirmed:
// Starlink) drop TCP to it, which left operators unable to log in while the
// server itself was perfectly healthy. The dashboard host (Vercel) stays
// reachable on every ISP. Same fix already shipped on the captive portal
// 2026-07-12; see vercel.json.
//
// The server mounts its routes under `/api` (`app.use('/api/auth', ...)`) and
// callers pass paths like `/auth/signin`, so the base must keep the `/api`
// suffix — same-origin means `/api`, not ''.
export function deriveApiUrl(): string {
   if (typeof window !== 'undefined' && window.location.hostname) {
      const host = window.location.hostname;
      const isProdLike =
         host.endsWith('.smartfi.ph') || host.endsWith('.mysmartfi.ph');
      if (isProdLike) return '/api'; // routed through the /api rewrite
   }
   const explicit = import.meta.env.VITE_API_URL;
   if (explicit) return explicit;
   if (typeof window !== 'undefined' && window.location.hostname) {
      return `${window.location.protocol}//${window.location.hostname}:9000/api`;
   }
   return 'http://localhost:9000/api';
}
